<div *ngIf="showHolidayMessage" class="my-4 p-5 bg-lightYellow rounded-md italic text-black relative">
    <button (click)="showHolidayMessage = false" class="absolute top-0 right-0 mt-2 mr-5 text-black">x</button>
    <div class=" font-bold">
        Please note: Due to the Christmas and New Year holidays, your submitted certification request in December may take
        longer than the usual. We expect to get back to you by early January.
    </div>
</div>